/**
 * saoChepBanGhi — BỎ THÔNG TIN KHÔNG ĐƯỢC MANG SANG BẢN SAO khi người dùng bấm "Sao chép"
 * (InputBase.copyItem — cả nút Sao chép trong MainForm — và DataListManager.handleCopy).
 *
 * Bản sao là một bản ghi MỚI do người dùng tự lập, nên không được thừa hưởng những thứ thuộc về BẢN GỐC:
 *   - NGUỒN ĐƠN HÀNG (`nguon_don`, dấu tự xác định `exfields.nguon_tu_dong`): để máy chủ tự xác định lại cho bản mới
 *     (core libs/nguonDon) — giữ nguyên là bản sao của đơn TikTok / Facebook cũng bị tính vào nguồn đó.
 *   - CHIẾN DỊCH / QUẢNG CÁO marketing (`ma_chien_dich`, `ma_quang_cao`…, dấu tự điền `exfields.mkt_tu_dien`), utm, mã click
 *     quảng cáo (gclid / fbclid / ttclid…), nguồn marketing / lead (`ma_nguon`, `lead_id`): mang theo là doanh thu bản sao bị
 *     cộng cho chiến dịch / quảng cáo của bản gốc -> SAI BÁO CÁO MARKETING.
 *   - PHIÊN CHAT (`exfields.hoi_thoai` khi tạo đơn từ màn hình chat, `conversation_id`, `platform_id` — mã người dùng trên
 *     Messenger / Zalo…): mang theo thì thông tin đơn của khách mới có thể bị gửi vào hội thoại của khách cũ -> LỘ THÔNG TIN.
 *   - MÃ ĐƠN TRÊN SÀN (`exfields.tiktok` / shopee / lazada / tiki): bản sao bị nhận nhầm là đơn sàn (đồng bộ tìm lại đơn theo mã).
 *   - Dấu bình luận / Lead Ads / điểm chạm (`exfields.binh_luan`, `post_id`, `fb_campaign_id`, `gan_tay`, `lien_he_trung`),
 *     file đính kèm hệ thống (`__files__`, `__supports__`).
 *   - Riêng LEAD (marketing_lead): định danh + kết quả xử lý của người cũ (mã lead, khách đã chuyển đổi, cơ hội, đơn, khoá chống
 *     trùng SĐT / email, điểm hành vi, giai đoạn, SLA, phân tích AI…).
 * Thêm field marketing / chat mới lên chứng từ thì THÊM VÀO ĐÂY (test: packages/scripts/sao-chep-ban-ghi-test.js đối chiếu).
 *
 * Module thuần (không import) — test nạp thẳng bằng cách bỏ khối export cuối file.
 */
const TRUONG_BO_KHI_SAO_CHEP = [
  // nguồn đơn hàng
  'nguon_don', 'ten_nguon_don',
  // chiến dịch / quảng cáo marketing trên chứng từ bán
  'ma_chien_dich', 'ten_chien_dich', 'ma_quang_cao', 'ten_quang_cao',
  // nguồn marketing / lead mà bản ghi đến từ (cơ hội, lead)
  'ma_nguon', 'ten_nguon', 'lead_id',
  // utm / mã click quảng cáo
  'utm', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid',
  // phiên chat / định danh người dùng trên kênh
  'hoi_thoai', 'conversation_id', 'platform_id',
];

const EXFIELDS_BO_KHI_SAO_CHEP = [
  'nguon_tu_dong', 'mkt_tu_dien', 'hoi_thoai',
  'tiktok', 'shopee', 'lazada', 'tiki',
  'utm', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid',
  'fb_campaign_id', 'post_id', 'binh_luan', 'gan_tay', 'lien_he_trung',
  '__supports__', '__files__',
];

/** Field bỏ thêm theo màn hình (mã chức năng / api code). */
const BO_THEO_MA = {
  marketing_lead: [
    'ma_lead', 'kenh', 'ma_kh', 'id_cohoi', 'id_don_hang', 'doanh_thu', 'sdt_chuan', 'email_chuan',
    'giai_doan', 'giai_doan_luc', 'diem_hanh_vi', 'diem_hanh_vi_luc', 'diem_giam_luc',
    'lan_tuong_tac_dau', 'lan_tuong_tac_gan', 'lan_phan_hoi_dau', 'sla_muc', 'sla_nhac_luc',
    'nuoi_duong_luc', 'nuoi_duong_kich_ban', 'ngay_that_bai',
    'ket_qua_ai', 'ai_de_xuat', 'ai_nhu_cau', 'ai_tro_ngai', 'ai_tom_tat', 'ai_muc_do', 'ai_phan_tich_luc',
  ],
};

/**
 * Bỏ (tại chỗ) các thông tin trên khỏi bản sao. Trả về chính đối tượng đó.
 * @param ban bản sao (đã clone từ bản gốc)
 * @param ma  mã màn hình / api code (vd 'dh2', 'marketing_lead') — để bỏ thêm field riêng của màn hình
 */
function boThongTinKhiSaoChep(ban, ma) {
  if (!ban || typeof ban !== 'object') return ban;
  for (const k of TRUONG_BO_KHI_SAO_CHEP) delete ban[k];
  for (const k of BO_THEO_MA[String(ma || '').toLowerCase()] || []) delete ban[k];
  const ex = ban.exfields;
  if (ex && typeof ex === 'object' && !Array.isArray(ex)) {
    for (const k of EXFIELDS_BO_KHI_SAO_CHEP) delete ex[k];
  }
  return ban;
}

export { TRUONG_BO_KHI_SAO_CHEP, EXFIELDS_BO_KHI_SAO_CHEP, BO_THEO_MA, boThongTinKhiSaoChep };
